/* WeldRda (travail 21): product page price block + "Le look complet" panel.
   1. Product page: the amounts in "Comment ça marche ?" (price, total with delivery, rest with the minimum
      deposit) and the look total follow the chosen variant (assets/wr.js sets the variant input first,
      this file reads it).
   2. Look panel (snippets/wr-look-set): total of the chosen pieces; one button adds every piece to the
      cart, then opens the cart drawer with the same theme cart events as assets/wr.js.
      Sizes are never pre-selected: the button says how many sizes are still missing. */
(function () {
'use strict';
function formatDH(cents) {
var n = Math.round(cents / 100);
return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' DH';
}
function readJSON(el) {
try { return JSON.parse(el ? el.textContent : '[]'); } catch (e) { return []; }
}
function num(el, attr) {
var v = parseInt(el ? el.getAttribute(attr) : '', 10);
return isNaN(v) ? 0 : v;
}
function routeRoot() {
return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
}
/* Theme cart events (@shopify/events) through a module script, as in assets/wr.js. */
var evPromise = null;
function cartEvents() {
if (evPromise) return evPromise;
evPromise = new Promise(function (resolve) {
if (window.__wrCartLinesEv) { resolve(window.__wrCartLinesEv); return; }
var done = false;
function finish() { if (done) return; done = true; resolve(window.__wrCartLinesEv || null); }
window.addEventListener('wr:cart-events', finish, { once: true });
var s = document.createElement('script');
s.type = 'module';
s.textContent = "import { CartLinesUpdateEvent } from '@shopify/events'; window.__wrCartLinesEv = CartLinesUpdateEvent; window.dispatchEvent(new Event('wr:cart-events'));";
document.head.appendChild(s);
setTimeout(finish, 4000);
});
return evPromise;
}
function openDrawer(drawer) {
try {
if (typeof drawer.open === 'function') { drawer.open(); return; }
if (typeof drawer.showDialog === 'function') { drawer.showDialog(); return; }
var trigger = document.querySelector('[aria-controls="cart-drawer"]');
if (trigger) { trigger.click(); return; }
} catch (e) {}
window.location.href = routeRoot() + 'cart';
}

/* 1. Product page amounts */
function initMain(root) {
if (root.hasAttribute('data-set-item') || root.getAttribute('data-wr-pay') === '1') return;
var pay = root.querySelector('[data-pay]');
var rest = root.querySelector('[data-pay-rest]');
var total = root.querySelector('[data-pay-total]');
var price = root.querySelector('[data-pay-price]');
var look = root.querySelector('[data-look-total]');
if (!pay && !look) return;
root.setAttribute('data-wr-pay', '1');
var variants = readJSON(root.querySelector('[data-wr-variants]'));
var input = root.querySelector('[data-variant-input]');
function sync() {
var id = input ? String(input.value) : '';
var v = null;
for (var i = 0; i < variants.length; i++) { if (String(variants[i].id) === id) { v = variants[i]; break; } }
if (!v) return;
if (pay) {
var withShip = v.price + num(pay, 'data-ship');
if (price) price.textContent = formatDH(v.price);
if (total) total.textContent = formatDH(withShip);
if (rest) rest.textContent = formatDH(Math.max(0, withShip - num(pay, 'data-dep')));
}
if (look) look.textContent = formatDH(v.price + num(look, 'data-base'));
}
root.addEventListener('change', function () { setTimeout(sync, 0); });
}

/* 2. Look panel */
function initSet(dlg) {
if (dlg.getAttribute('data-wr-set-bound') === '1') return;
dlg.setAttribute('data-wr-set-bound', '1');
var items = Array.prototype.slice.call(dlg.querySelectorAll('[data-set-item]'));
var btn = dlg.querySelector('[data-set-add]');
var label = dlg.querySelector('[data-set-label]');
var totalEl = dlg.querySelector('[data-set-total]');
var msg = dlg.querySelector('[data-set-msg]');
var sid = dlg.getAttribute('data-sid');
var busy = false, tried = false;
if (!btn || !items.length) return;
items.forEach(function (it) { it._wrV = readJSON(it.querySelector('[data-wr-variants]')); });
function chosen(it) {
var opts = [], missing = false, any = false;
it.querySelectorAll('.wr-opt').forEach(function (fs) {
any = true;
var c = fs.querySelector('input[type=radio]:checked');
opts[parseInt(fs.getAttribute('data-option-index'), 10)] = c ? c.value : null;
if (!c) missing = true;
});
return { opts: opts, missing: missing, any: any };
}
function match(list, opts) {
for (var i = 0; i < list.length; i++) {
var v = list[i], ok = true;
for (var k = 0; k < opts.length; k++) { if (opts[k] != null && v.options[k] !== opts[k]) { ok = false; break; } }
if (ok) return v;
}
return null;
}
function state(it) {
var list = it._wrV;
var c = chosen(it);
if (!c.any) return { v: list[0] || null, price: list[0] ? list[0].price : 0, missing: false };
var v = match(list, c.opts);
return { v: c.missing ? null : v, price: v ? v.price : (list[0] ? list[0].price : 0), missing: c.missing };
}
function showMsg(text) {
if (!msg) return;
msg.textContent = text || '';
msg.hidden = !text;
}
function refresh() {
var total = 0, need = 0, out = 0;
items.forEach(function (it) {
var st = state(it);
total += st.price || 0;
var isOut = !st.missing && (!st.v || !st.v.available);
if (st.missing) need++;
else if (isOut) out++;
it.classList.toggle('is-missing', tried && st.missing);
var warn = it.querySelector('[data-set-warn]');
if (warn) {
var text = isOut ? 'Cette taille est épuisée : choisissez-en une autre.' : (tried && st.missing ? 'Choisissez votre taille.' : '');
warn.textContent = text;
warn.hidden = !text;
}
});
if (totalEl) totalEl.textContent = formatDH(total);
if (busy) return;
if (need) {
label.textContent = need === items.length ? 'Choisissez les tailles' : (need === 1 ? 'Encore 1 taille à choisir' : 'Encore ' + need + ' tailles à choisir');
btn.setAttribute('aria-disabled', 'true');
} else if (out) {
label.textContent = 'Une taille est épuisée';
btn.setAttribute('aria-disabled', 'true');
} else {
label.textContent = 'Ajouter les ' + items.length + ' pièces au panier';
btn.removeAttribute('aria-disabled');
}
}
/* Same colour as on the page for this piece (the size stays to choose). */
function syncMain() {
var main = dlg.querySelector('[data-set-main]');
var page = document.getElementById('wr-pdp-' + sid);
if (!main || !page) return;
var ci = parseInt(page.getAttribute('data-color-index'), 10);
if (isNaN(ci) || ci < 0) return;
var pc = page.querySelector('.wr-opt[data-option-index="' + ci + '"] input[type=radio]:checked');
var fs = main.querySelector('.wr-opt[data-option-index="' + ci + '"]');
if (!pc || !fs) return;
var cur = fs.querySelector('input[type=radio]:checked');
if (cur && cur.value === pc.value) return;
fs.querySelectorAll('input[type=radio]').forEach(function (r) {
if (r.value === pc.value) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
});
}
function markDone() {
document.querySelectorAll('[data-open-dialog="' + dlg.id + '"]').forEach(function (b) {
b.classList.add('is-added');
var l = b.querySelector('[data-look-all-label]');
if (l) l.textContent = 'Look ajouté au panier';
});
document.querySelectorAll('[data-open-dialog^="wr-qa-' + sid + '-"]').forEach(function (b) {
b.classList.add('is-added');
var l = b.querySelector('[data-look-label]');
if (l) l.textContent = 'Ajouté';
});
}
function add(lines) {
var r = routeRoot();
busy = true;
btn.setAttribute('aria-disabled', 'true');
label.textContent = 'Ajout…';
showMsg('');
var ids = [];
document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) { ids.push(el.getAttribute('data-section-id')); });
var body = { items: lines };
if (ids.length) body.sections = ids.join(',');
var main = dlg.querySelector('[data-set-main]');
var pid = main ? (main.getAttribute('data-product-id') || '') : '';
var Ev = null, deferred = null, added = false;
cartEvents().then(function (C) {
Ev = C || null;
if (Ev) {
deferred = Ev.createPromise();
btn.dispatchEvent(new Ev({ action: 'add', context: 'product', lines: lines.map(function (l) { return { merchandiseId: String(l.id), quantity: l.quantity }; }), promise: deferred.promise }));
}
return fetch(r + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }, body: JSON.stringify(body) });
})
.then(function (res) { return res.json(); })
.then(function (res) {
var failed = !!(res && res.status);
if (!failed) added = true;
return fetch(r + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (x) { return x.json(); }).then(function (cart) {
if (deferred) {
deferred.resolve({ cart: Ev.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'product-form-component', sourceId: 'wr-look-set', itemCount: lines.length, productId: pid, sections: failed ? undefined : res.sections, didError: failed } });
}
if (failed) { showMsg(res.description || res.message || 'Impossible d’ajouter ces articles.'); return; }
if (dlg.open) dlg.close();
markDone();
var drawer = document.getElementById('cart-drawer');
if (!deferred || !drawer) { window.location.href = r + 'cart'; return; }
openDrawer(drawer);
});
})
.catch(function (err) {
if (deferred) { try { deferred.reject(err); } catch (e) {} }
if (added) { window.location.href = r + 'cart'; }
else { showMsg('Connexion impossible. Vérifiez votre internet et réessayez.'); }
})
.then(function () { busy = false; refresh(); });
}
btn.addEventListener('click', function () {
if (busy) return;
var lines = [], firstBad = null;
items.forEach(function (it) {
var st = state(it);
if (st.missing || !st.v || !st.v.available) { if (!firstBad) firstBad = it; }
else lines.push({ id: st.v.id, quantity: 1 });
});
if (firstBad) {
tried = true;
refresh();
try { firstBad.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { firstBad.scrollIntoView(); }
return;
}
add(lines);
});
dlg.addEventListener('change', function () { setTimeout(refresh, 0); });
dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
dlg.querySelectorAll('[data-close-dialog]').forEach(function (b) { b.addEventListener('click', function () { dlg.close(); }); });
document.querySelectorAll('[data-open-dialog="' + dlg.id + '"]').forEach(function (b) {
b.addEventListener('click', function () { syncMain(); refresh(); });
});
refresh();
}

function init() {
document.querySelectorAll('[data-wr-product]').forEach(initMain);
document.querySelectorAll('dialog[data-wr-set]').forEach(initSet);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
else init();
document.addEventListener('shopify:section:load', init);
})();
